// src/menu-items/user.jsx

const user = {
  id: 'group-user-navigation',
  title: 'Navigation',
  type: 'group',
  children: [
    // ── Top-level ─────────────────────────────────────────────
    {
      id: 'dashboard',
      title: 'Dashboard',
      type: 'item',
      icon: 'ph ph-house-line',
      url: '/'
    },
    {
      id: 'targets-assets',
      title: 'Targets',
      type: 'item',
      icon: 'ph ph-crosshair',
      url: '/targets',
      breadcrumbs: false
    },
    {
      id: 'threat-alerts',
      title: 'Threat alerts',
      type: 'item',
      icon: 'ph ph-warning-octagon',
      url: '/threat-alerts',
      breadcrumbs: false
    },
    {
      id: 'target-overview',
      title: 'Target overview',
      type: 'item',
      icon: 'ph ph-squares-four',
      url: '/target-overview',
      breadcrumbs: false
    },

    // ── Discovery ─────────────────────────────────────────────
    {
      id: 'discovery-group',
      title: 'Discovery',
      type: 'collapse',
      icon: 'ph ph-binoculars',
      children: [
        {
          id: 'fuzzscan-recon',
          title: 'Reconnaissance',
          type: 'item',
          url: '/recon',
          breadcrumbs: false
        },
        {
          id: 'fuzzscan-enum',
          title: 'Enumeration',
          type: 'item',
          url: '/enum',
          breadcrumbs: false
        },
        {
          id: 'fuzzscan-network-map',
          title: 'Network map',
          type: 'item',
          url: '/network-map',
          breadcrumbs: false
        },
        {
          id: 'fuzzscan-attack-surface',
          title: 'Attack surface',
          type: 'item',
          url: '/attack-surface',
          breadcrumbs: false
        },
        {
          id: 'fuzzscan-website-changes',
          title: 'Website changes',
          type: 'item',
          url: '/website-changes',
          breadcrumbs: false
        },
        {
          id: 'fuzzscan-dorks',
          title: 'Dork Engine',
          type: 'item',
          url: '/dorks',
          breadcrumbs: false
        },
        {
          id: 'fuzzscan-surface-search',
          title: 'Surface Search',
          type: 'item',
          url: '/surface-search',
          breadcrumbs: false
        },
        {
          id: 'fuzzscan-passive-intel',
          title: 'Passive Intel',
          type: 'item',
          url: '/passive-intel',
          breadcrumbs: false
        },
        {
          id: 'fuzzscan-blacklist',
          title: 'Blacklist check',
          type: 'item',
          url: '/blacklist',
          breadcrumbs: false
        }
      ]
    },

    // ── Scanning ──────────────────────────────────────────────
    {
      id: 'scanning-group',
      title: 'Scanning',
      type: 'collapse',
      icon: 'ph ph-target',
      children: [
        {
          id: 'fuzzscan-scans',
          title: 'Web scans',
          type: 'item',
          url: '/web-scans',
          breadcrumbs: false
        },
        {
          id: 'fuzzscan-network-scans',
          title: 'Network scans',
          type: 'item',
          url: '/network-scans',
          breadcrumbs: false
        },
        {
          id: 'fuzzscan-cloud-scans',
          title: 'Cloud scans',
          type: 'item',
          url: '/cloud-scans',
          breadcrumbs: false
        },
        {
          id: 'fuzzscan-mobile-scans',
          title: 'Mobile scans',
          type: 'item',
          url: '/mobile-scans',
          breadcrumbs: false
        },
        {
          id: 'fuzzscan-api-security',
          title: 'API security',
          type: 'item',
          url: '/api-security',
          breadcrumbs: false
        },
        {
          id: 'fuzzscan-fuzzing',
          title: 'Fuzzing',
          type: 'item',
          url: '/fuzzing',
          breadcrumbs: false
        },
        {
          id: 'fuzzscan-cloud-posture',
          title: 'Cloud posture',
          type: 'item',
          url: '/cloud-posture',
          breadcrumbs: false
        },
        {
          id: 'fuzzscan-oast-monitor',
          title: 'OAST monitor',
          type: 'item',
          url: '/oast-monitor',
          breadcrumbs: false
        },
        {
          id: 'fuzzscan-scan-templates',
          title: 'Scan templates',
          type: 'item',
          url: '/scan-templates',
          breadcrumbs: false
        },
        {
          id: 'fuzzscan-schedules',
          title: 'Scan schedules',
          type: 'item',
          url: '/schedules',
          breadcrumbs: false
        },
        {
          id: 'fuzzscan-jobs',
          title: 'Scan jobs',
          type: 'item',
          url: '/jobs',
          breadcrumbs: false
        }
      ]
    },

    // ── Findings ──────────────────────────────────────────────
    {
      id: 'vuln-group',
      title: 'Findings',
      type: 'collapse',
      icon: 'ph ph-bug-beetle',
      children: [
        {
          id: 'fuzzscan-vulns',
          title: 'Findings',
          type: 'item',
          url: '/vulns',
          breadcrumbs: false
        },
        {
          id: 'fuzzscan-ad-audit',
          title: 'AD Audit',
          type: 'item',
          url: '/ad-audit',
          breadcrumbs: false
        },
        {
          id: 'fuzzscan-secrets',
          title: 'Secrets detection',
          type: 'item',
          url: '/secrets',
          breadcrumbs: false
        },
        {
          id: 'fuzzscan-remediation',
          title: 'Remediation center',
          type: 'item',
          url: '/remediation',
          breadcrumbs: false
        },
        {
          id: 'fuzzscan-cves',
          title: 'CVE catalog',
          type: 'item',
          url: '/cves',
          breadcrumbs: false
        },
        {
          id: 'fuzzscan-sbom',
          title: 'SBOM',
          type: 'item',
          url: '/sbom',
          breadcrumbs: false
        },
        {
          id: 'fuzzscan-compliance',
          title: 'Compliance matrix',
          type: 'item',
          url: '/compliance',
          breadcrumbs: false
        },
        {
          id: 'fuzzscan-vex',
          title: 'VEX advisories',
          type: 'item',
          url: '/vex',
          breadcrumbs: false
        },
        {
          id: 'fuzzscan-risk',
          title: 'Risk overview',
          type: 'item',
          url: '/risk',
          breadcrumbs: false
        },
        {
          id: 'fuzzscan-cvss-calculator',
          title: 'CVSS Calculator',
          type: 'item',
          url: '/cvss-calculator',
          breadcrumbs: false
        }
      ]
    },

    // ── Intel & Cases ─────────────────────────────────────────
    {
      id: 'intel-group',
      title: 'Intel & Cases',
      type: 'collapse',
      icon: 'ph ph-briefcase-metal',
      children: [
        {
          id: 'fuzzscan-cases',
          title: 'Cases',
          type: 'item',
          url: '/cases',
          breadcrumbs: false
        },
        {
          id: 'fuzzscan-intel-feeds',
          title: 'Intel feeds',
          type: 'item',
          url: '/intel/feeds',
          breadcrumbs: false
        },
        {
          id: 'fuzzscan-exploits',
          title: 'Exploit database',
          type: 'item',
          url: '/exploits',
          breadcrumbs: false
        },
      ]
    },

    // ── Engagements (top-level) ───────────────────────────────
    {
      id: 'engagements-group',
      title: 'Engagements',
      type: 'item',
      icon: 'ph ph-clipboard-text',
      url: '/engagements',
      breadcrumbs: false
    },

    // ── Reporting ─────────────────────────────────────────────
    {
      id: 'reporting-group',
      title: 'Reporting',
      type: 'collapse',
      icon: 'ph ph-file-text',
      children: [
        {
          id: 'fuzzscan-reporting',
          title: 'Reporting',
          type: 'item',
          url: '/reporting',
          breadcrumbs: false
        },
        {
          id: 'fuzzscan-executive',
          title: 'Executive summary',
          type: 'item',
          url: '/executive',
          breadcrumbs: false
        },
        {
          id: 'fuzzscan-analytics',
          title: 'Analytics & KPIs',
          type: 'item',
          url: '/analytics',
          breadcrumbs: false
        },
        {
          id: 'fuzzscan-scan-diff',
          title: 'Scan comparison',
          type: 'item',
          url: '/scan-diff',
          breadcrumbs: false
        },
        {
          id: 'fuzzscan-exports',
          title: 'Export center',
          type: 'item',
          url: '/exports',
          breadcrumbs: false
        },
        {
          id: 'fuzzscan-artifacts',
          title: 'Evidence',
          type: 'item',
          url: '/artifacts',
          breadcrumbs: false
        },
        {
          id: 'fuzzscan-supply-chain',
          title: 'Supply chain',
          type: 'item',
          url: '/supply-chain',
          breadcrumbs: false
        },
        {
          id: 'fuzzscan-finding-fingerprints',
          title: 'Repeated findings',
          type: 'item',
          url: '/finding-fingerprints',
          breadcrumbs: false
        },
        {
          id: 'fuzzscan-webhooks',
          title: 'Webhooks',
          type: 'item',
          url: '/webhooks',
          breadcrumbs: false
        },
        {
          id: 'fuzzscan-shared-links',
          title: 'Shared links',
          type: 'item',
          url: '/shared-links',
          breadcrumbs: false
        }
      ]
    },

    // ── User Settings ─────────────────────────────────────────
    {
      id: 'settings-group',
      title: 'User settings',
      type: 'collapse',
      icon: 'ph ph-gear-six',
      children: [
        {
          id: 'fuzzscan-settings-account',
          title: 'Account settings',
          type: 'item',
          url: '/settings',
          breadcrumbs: false
        },
        {
          id: 'fuzzscan-settings-api-keys',
          title: 'Third-party keys',
          type: 'item',
          url: '/settings/third-party-keys',
          breadcrumbs: false
        },
        {
          id: 'fuzzscan-settings-web-auth-profiles',
          title: 'Saved logins',
          type: 'item',
          url: '/settings/web-auth-profiles',
          breadcrumbs: false
        },
        {
          id: 'fuzzscan-settings-sessions',
          title: 'Active sessions',
          type: 'item',
          url: '/settings/sessions',
          breadcrumbs: false
        },
        {
          id: 'fuzzscan-console-keys',
          title: 'Console keys',
          type: 'item',
          url: '/settings/console-keys',
          breadcrumbs: false
        },
        {
          id: 'fuzzscan-settings-billing',
          title: 'Plan and usage',
          type: 'item',
          url: '/settings/billing',
          breadcrumbs: false
        },
        {
          id: 'my-work',
          title: 'My Work',
          type: 'item',
          url: '/my-work',
          breadcrumbs: false
        }
      ]
    }
  ]
};

export default user;
